import { Injectable, inject } from '@angular/core';

import { AccaBoostConfig } from '@frontend/sports/common/client-config-data-access';
import { emitAfter } from '@frontend/sports/common/core/utils/emit-after';
import { OddsFormatterService, OddsOperations } from '@frontend/sports/odds/feature';
import { UserOddsFormatSettingsService } from '@frontend/sports/user/feature';
import { Observable, Subject, merge, share } from 'rxjs';

import { AccaBoostTokenMinOdds } from '../../reward-tokens/reward-tokens.model';
import { INotification } from '../model';
import { AccaBoostNotificationHandlerService } from './acca-boost-notification-handler.service';

@Injectable()
export class AccaBoostNotificationService {
    private readonly manualNotification = new Subject<INotification | null>();
    private readonly userOddsFormatSettingsService = inject(UserOddsFormatSettingsService);

    constructor(
        private notificationHandler: AccaBoostNotificationHandlerService,
        private accaBoostConfig: AccaBoostConfig,
        private oddsFormatterService: OddsFormatterService,
    ) {}

    getNotifications$(): Observable<INotification | null> {
        const data$ = merge(this.notificationHandler.notification$, this.manualNotification);

        const timeout$ = data$.pipe(emitAfter(null, (data) => data.duration ?? this.accaBoostConfig.notificationDuration));

        return merge(data$, timeout$).pipe(share());
    }

    hideNotification(): void {
        this.manualNotification.next(null);
    }

    areNotificationsEnabled(): boolean {
        return this.accaBoostConfig.areNotificationsEnabled;
    }

    getUserBettingOddsFormatMinOdds(minOddsPerLeg: AccaBoostTokenMinOdds): string {
        const minOdds = OddsOperations.createOdds({
            odds: minOddsPerLeg.european,
            numerator: minOddsPerLeg.britishNumerator,
            denominator: minOddsPerLeg.britishDenominator,
            americanOdds: minOddsPerLeg.american,
        });

        return this.oddsFormatterService.format(minOdds, { displayFormat: this.userOddsFormatSettingsService.oddsFormat });
    }
}
